module.exports = __webpack_public_path__ + "img/emoji_feiwen.d1aade5a.png";